<script setup>
import Footer from "@/layouts/components/Footer.vue"
import Rating from "@/views/home/Rating.vue"
import Ranking from "@/views/home/Ranking.vue"
// import Remind from "@/views/home/Remind.vue"
import PlusInfo from "@/views/home/PlusInfo.vue"
import ReportService from "@/services/ReportService"

import { IS_MM_REPORTS_LIST, IS_MB_REPORTS_LIST, IS_ALL_REPORTS_LIST } from "@/utils/constant"
import { useAuthStore } from "@/stores/authStore"
import { useAppStore } from "@/stores/appStore"
import { headerAccountSchoolsReport } from "@/utils/headers"
import { router } from "@/plugins/1.router"
import { useCustomSwal } from "@/composables/usePopup"

definePage({
  meta: {
    requiresAuth: true,
  },
})

const CURRENT_YEAR = import.meta.env.VITE_CURRENT_YEAR
const START_DATE = import.meta.env.VITE_START_DATE
const END_DATE = import.meta.env.VITE_END_DATE
const CAMPAIGN = import.meta.env.VITE_CAMPAIGN

const { showCustomSwal } = useCustomSwal()
const authStore = useAuthStore()
const appStore = useAppStore()
const openPanels = ref([0])
const admin = authStore.isAdmin
const isMM = ref(+IS_MM_REPORTS_LIST)
const isMB = ref(+IS_MB_REPORTS_LIST)
const isAll = ref(+IS_ALL_REPORTS_LIST)

const infoBlocksClose = ref([
  {
    id: 1,
    position: "top",
    type: "alert",
    content: `
          ${$gettext("The Ranking ")}
          ${+CURRENT_YEAR + 1} ${$gettext("of the best Master’s, MBA, and DBA programs will be published on"
    )}
          <a class="text-blue" target="_blank" href="https://www.best-masters.com/">https://www.best-masters.com/</a>
          ${$gettext("in March ")} ${+CURRENT_YEAR + 1}
      </p>
      `,
  },
])
const infoBlocksOpen = ref([
  {
    id: 1,
    position: "top",
    type: "alert",
    content: `
      <p>
          ${$gettext("The Eduniversal Survey ")}
          ${+CURRENT_YEAR} ${$gettext("for the development of the rankings"
    )}
    ${+CURRENT_YEAR + 1}
          ${$gettext("is open from ")} ${START_DATE} to ${END_DATE}
      </p>
      <p>
          ${$gettext("The Ranking ")}
          ${+CURRENT_YEAR + 1} ${$gettext("of the best Master’s, MBA, and DBA programs will be published on"
    )}
          <a class="text-blue" target="_blank" href="https://meilleurs-bachelors.fr/">https://meilleurs-bachelors.fr/</a>
          ${$gettext("in January ")} ${+CURRENT_YEAR + 1}
      </p>
      <p>
          ${$gettext("The Ranking ")}
          ${+CURRENT_YEAR + 1} ${$gettext("of the best Master’s, MBA, and DBA programs will be published on"
    )}
          <a class="text-blue" target="_blank" href="https://www.meilleurs-masters.com/">https://www.meilleurs-masters.com/</a>
          ${$gettext("in March ")} ${+CURRENT_YEAR + 1}
      </p>
      `,
  },
])
const dataReports = ref([])
const loading = ref(false)

function redirectToProgram(id, item) {
  router.push({ 
    name: 'report-school-program-id', 
    params: {
      id: id,
      program: item.hash
    } 
  })
}
async function getListReport() {
  try {
    loading.value = true
    const response = await ReportService.listReport()
    let result = response

    if (+IS_MB_REPORTS_LIST === 1) {
      result = response.map(item => ({
        school: item.school,
        programs: item.programs.filter(p => p.programLevel === 2)
      }))
      dataReports.value = result
      appStore.setListReportInHomePage(result)
    } else if (+IS_MM_REPORTS_LIST === 1) {
      result = response.map(item => ({
        school: item.school,
        programs: item.programs.filter(p => p.programLevel === 1)
      }))
      dataReports.value = result
      appStore.setListReportInHomePage(result)
    } else if (+IS_ALL_REPORTS_LIST === 1) {
      dataReports.value = response
      appStore.setListReportInHomePage(response)
    }
  } catch (error) {
    console.log(error)
      await showCustomSwal({
        title: $gettext("Error"),
        text:
          error.message ||
          $gettext("An error has occurred."),
      })
  } finally {
    loading.value = false
  }
}
function handleDownload(item) {
  window.open(item.linkDownload, '_blank')
}
// watch(
//   () => +CAMPAIGN,
//   async (newVal) => {
//     if (newVal === 0) {
//       if (admin != 1 || !admin) {
//         await authStore.logout()
//       }
//     }
//   },
//   { immediate: true }
// )

watch([isMM, isMB, isAll], async () => {
  await getListReport()
  window.location.reload()
})

onMounted( async () => {
  if (+CAMPAIGN == 0) {
    await nextTick()
    await getListReport()
  }
})
</script>

<template>
  <div v-if="+CAMPAIGN == 1">
    <ListHeadBox
      class="bg-white"
      :title="
        $gettext(`Welcome to the Eduniversal Programs Surveys Platform`)
      "
      :toggleVerticalOverlayNavActive="$attrs.toggleVerticalOverlayNavActive"
      :center="true"
    >
      <!-- <template #caption>
        <div class="text-center font-weight-bold">{{ $gettext("This platform is in English and open to any local or international program, regardless of the language of instruction.") }}</div>
      </template> -->
    </ListHeadBox>
    <div class="home">
      <div class="px-5" v-if="+CAMPAIGN !== 1">
        <InfoBlock
          v-for="item in infoBlocksOpen.filter((item) => item.position === 'top')"
          :key="item.id"
          :infoBlock="item"
          class="mb-10"
        />
      </div>
      <div class="px-5" v-else>
        <InfoBlock
          v-for="item in infoBlocksClose.filter(
            (item) => item.position === 'top'
          )"
          :key="item.id"
          :infoBlock="item"
          class="mb-10"
        />
      </div>
      <div class="home__container">
        <Rating />
        <Ranking />
        <!-- <Remind /> -->
        <PlusInfo />
      </div>

      <VCard style="margin: 30px 16px 50px 16px">
        <ContactWithUs />
      </VCard>
    </div>
  </div>

  <div v-else class="text-black-900 container_table_account_school" style="margin-bottom: 100px;" >
    <v-row>
      <v-col cols="12" class="bg-primary-blur d-flex justify-center align-center">
        <h1 class="text-center text-black-900 font-weight-medium text-bree px-5 py-5" style="max-width: 645px;">{{ $gettext("Satisfaction survey reports") }}</h1> 
      </v-col>
    </v-row>

    <v-row class="px-6 py-5 text-justify" style="font-size: 16px;">
      <v-col cols="12" class="">
        <p class="mb-0 font-weight-bold">{{ $gettext("The Eduniversal Ranking is based on three main criteria:") }}</p>
      </v-col>
      <v-col cols="12">
        <ul class="pl-6">
          <li>{{ $gettext("The reputation of the program") }}</li>
          <li>{{ $gettext("Salaries, career prospects and further studies upon completion of the program") }}</li>
          <li>{{ $gettext("The student satisfaction feedback") }}</li>
        </ul>
      </v-col>
      <v-col cols="12">
        <p class="mb-0">{{ $gettext("As soon as the ranking is published, you can access all your scores upon simple request at the following address:") }}<br /> <a class="text-primary" href="mailto:marie-anne.binet@eduniversal-group.com">marie-anne.binet@eduniversal-group.com</a>. {{ $gettext("In the meantime, we invite you to preview the satisfaction feedback from your students surveyed in our latest study.") }}</p>
      </v-col>
      <v-col cols="12">
        <p class="mb-0">{{ $gettext("To ensure complete confidentiality for them, the comments are anonymous.") }}</p>
      </v-col>
      <v-col cols="12">
        <p class="mb-0">{{ $gettext("Enjoy your reading!") }}</p>
      </v-col>
      <v-col cols="12">
        <p class="mb-0">{{ $gettext("The Eduniversal Team") }}</p>
      </v-col>
    </v-row>

    <v-row class="px-6" v-for="(item, index) in dataReports" :key="index">
      <v-col cols="12" class="d-flex gap-6 align-center">
        <v-card width="105" height="105" class="d-flex justify-center align-center" style="box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1) !important">
          <img v-if="item.school.logo" :src="item.school.logo" alt="logo school" loading="lazy" class="w-100" >
          <div v-else class="d-flex justify-center flex-column gap-2 align-center w-100 h-100" style="background: #e3e3ed;">
            <img src="@/assets/logo-short-white.svg" alt="">
          </div>
        </v-card>
        <div class="d-flex flex-column gap-2">
          <h2 class="font-weight-medium text-bree">{{ item.school.name }}</h2>
          <h3 class="text-second-primary font-weight-bold" style="font-size: 18px;">{{ $gettext("Program(s)") }} : {{ item.programs.length }}</h3>
        </div>
      </v-col>
      <v-col cols="12">
        <VExpansionPanels v-model="openPanels[index]" multiple variant="accordion" class="expansion-panels-width-border d-flex flex-column gap-4">
          <v-card v-for="program in item.programs" :key="program.id" class="">
            <VExpansionPanel elevation="0">
              <VExpansionPanelTitle
                collapse-icon="tabler-minus"
                expand-icon="tabler-plus"
              >
                <h3 :class="[program.programLevel === 1 ? 'active-master' : 'active-mb']">{{ program.name }}</h3>
              </VExpansionPanelTitle>

              <VExpansionPanelText>
                <v-data-table
                  :headers="headerAccountSchoolsReport"
                  :items="[...program.reports].sort((a, b) => b.year - a.year)"
                  :items-per-page="-1"
                >
                  <template #item.actions="{ item }">
                    <div class="d-flex justify-center align-center gap-2">
                      <v-btn
                        :color="program.programLevel === 1 ? 'second-primary' : 'mb'"
                        density="compact"
                        @click="redirectToProgram(program.id, item)"
                      >
                        <VIcon
                          icon="tabler-eye"
                          size="16"
                          color="on-secondary"
                          class="mr-1"
                        />
                        {{ $gettext("View") }}
                      </v-btn>
                      <v-btn
                        :color="program.programLevel === 1 ? 'second-primary' : 'mb'"
                        density="compact"
                        @click="handleDownload(item)"
                      >
                        <VIcon
                          icon="tabler-download"
                          size="16"
                          color="on-secondary"
                          class="mr-1"
                        />
                        {{ $gettext("Download") }}
                      </v-btn>
                    </div>
                  </template>
                  <template #item.participationRate="{ item }">
                    <span>{{ item.participationRate }}%</span>
                  </template>
                  <template #item.averageScore="{ item }">
                    <span>{{ item.averageScore.toFixed(2) }} / 5</span>
                  </template>
                  <template #bottom />
                </v-data-table>
              </VExpansionPanelText>
            </VExpansionPanel>
          </v-card>
        </VExpansionPanels>
      </v-col>
    </v-row>
  </div>

  <!-- Footer -->
  <div class="mt-5 mb-5">
    <Footer />
  </div>
  <Waiting :show="loading" />
</template>

<style lang="scss" scoped>
@import "@/assets/styles/pages/home.scss";
@import "@/assets/styles/pages/profile.scss";
</style>
 
